// Todo: PostalCode is not being sent from any component. This is an optional property which is used when user has selected postal code
import axios from "../../fetch-api/fetch-api";
import { IDetailedProductResponse } from "../interfaces/get-page-details/product-page.type";

export function getProductBySkuApi(sku: string) {
  return axios.get<IDetailedProductResponse>("s/get-product-by-sku-v4", {
    params: {
      sku,
    },
  });
}
